<script>
  import { chart } from "svelte-apexcharts";
  import { BigNumber } from "bignumber.js";
  import dayjs from 'dayjs';
  import { mainData } from "../stores.js";
  import { updateData, optionsAfbouw }  from "./updateData";
  import {onDestroy, onMount} from 'svelte';

  BigNumber.set({ 
                  DECIMAL_PLACES: 2,
                  FORMAT: {prefix: '€', decimalSeparator: ',', groupSeparator: '.', groupSize: 3,}  
                });
  let shown = false;
  onMount(() =>
    setTimeout(() => {
      shown = true;
    }, 500)
  );

  let chartOptions;              
  optionsAfbouw.subscribe(value => {chartOptions = value;});

  onDestroy(() => {optionsAfbouw.subscribe(value => {chartOptions = value;});});

</script>

{#if shown }
<div id="chart" use:chart={chartOptions} />
{/if}
